import { useState } from 'react'
import { ExperimentPopup } from 'src/Pages/Clients/components/Popups/ExperimentPopup'

export const NewExperiment = () => {
  const [newExperimentPopup, setNewExperimentPopup] = useState(false)
 

  return (
    <>
      <button className="btn" onClick={() => setNewExperimentPopup(true)}>
        Add new experiment
      </button>
      {newExperimentPopup && <ExperimentPopup handleNewExperiment={() => {}} setNewExperimentPopup={setNewExperimentPopup}  />}
    </>
  )
}
